<template>
  <PageWrapper
    :active-section="SECTION_SETTINGS"
    :active-page="PAGE_USER_ACCOUNT_SETTINGS"
    title="User Settings"
    :breadcrumbs="settingsBreadcrumbs"
    page-name="User Settings"
    align="left"
    width="full"
  >
    <iColumn gap="extraLarge">
      <UserAccountManagement />
      <iDivider />
      <UserSecurityManagement />
    </iColumn>
  </PageWrapper>
</template>

<script>
import { mapState } from "pinia";
import PageWrapper from "@/components/PageWrapper";
import { SECTION_SETTINGS, PAGE_USER_ACCOUNT_SETTINGS } from "@/constants/nav-constants";
import UserAccountManagement from "@/components/UserAccountManagement.vue";
import UserSecurityManagement from "@/components/UserSecurityManagement.vue";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "UserAccount",
  components: {
    UserAccountManagement,
    UserSecurityManagement,
    PageWrapper,
  },
  props: {},
  data() {
    return {
      SECTION_SETTINGS,
      PAGE_USER_ACCOUNT_SETTINGS,
    };
  },
  computed: {
    ...mapState(useGeneralStore, [
      "userAvatar",
      "settingsBreadcrumbs",
    ]),
  },
};
</script>

<style lang="scss" scoped>
.hide-cursor {
  :deep(.i-text-input) {
    caret-color: transparent;
  }
}
</style>
